export const columnsDashboardsData = [
    {
        id: 1,
        dashboard_title: 'Заявка',
        widgets: [
            {
                id: 1,
                widget_title: 'Додати замовлення',
                fields: [
                    {
                        id: 1,
                        name: '№ Замовлення',
                    },
                    {
                        id: 2,
                        name: 'Клієнт',
                    },
                    {
                        id: 3,
                        name: 'Телефон',
                    },
                    {
                        id: 4,
                        name: 'Адреса',
                    },
                ],
            },
        ],
    },
    {
        id: 2,
        dashboard_title: 'Доставка',
        widgets: [
            {
                id: 1,
                widget_title: 'Прибув до клієнта',
                fields: [
                    {
                        id: 1,
                        name: 'Вчасно',
                    },
                    {
                        id: 2,
                        name: 'Час 1',
                    },
                ],
            },
            {
                id: 2,
                widget_title: 'Видано клієнту',
                fields: [
                    {
                        id: 1,
                        name: 'Час 2',
                    },
                ],
            },
        ],
    },
    {
        id: 3,
        dashboard_title: 'Проблема',
        widgets: [
            {
                id: 1,
                widget_title: 'Опрацювати і закрити',
                fields: [
                    {
                        id: 1,
                        name: 'Результат розгляду',
                    },
                ],
            },
        ],
    },
];

export const usersData = [
    {
        id: 1,
        name: 'Корж М.',
        access: true,
    },
    {
        id: 2,
        name: 'Бондарчук С.',
        access: true,
    },
    {
        id: 3,
        name: 'Романчук Д.',
        access: true,
    },
    {
        id: 4,
        name: 'Васильчук Є.',
        access: true,
    },
    {
        id: 5,
        name: 'Бабіч В.',
        access: true,
    },
    {
        id: 6,
        name: 'Захарчук М.',
        access: true,
    },
    {
        id: 7,
        name: 'Лях П.',
        access: true,
    },
    {
        id: 8,
        name: 'Шевченко І.',
        access: true,
    },
    {
        id: 9,
        name: 'Лях П.',
        access: true,
    },
    {
        id: 10,
        name: 'Швець О.',
        access: true,
    },
    {
        id: 11,
        name: 'Коваленко Ф.',
        access: true,
    },
    {
        id: 12,
        name: 'Шевчук В.',
        access: true,
    },
    {
        id: 13,
        name: 'Івченко О.',
        access: true,
    },
    {
        id: 14,
        name: 'Шпак Я.',
        access: true,
    },
    {
        id: 15,
        name: 'Дорошенко Д.',
        access: true,
    },
    {
        id: 16,
        name: 'Шевченко І.',
        access: true,
    },
    {
        id: 17,
        name: 'Шевченко І.',
        access: true,
    },
    {
        id: 18,
        name: 'Шевченко А.',
        access: true,
    },
    {
        id: 19,
        name: 'Шевченко Б.',
        access: true,
    },
];
